import { Component, ViewChild, OnInit, Output, EventEmitter } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { DxDataGridComponent } from 'devextreme-angular';

import { AppService } from '@api';
import { SistemaService } from '@servicios/Sistema.Service';

import { AlertaEnum } from '@mensaje/Enumeraciones/MensajeEnumeraciones.enum';
import { MensajeService } from '@mensaje/Mensaje.Service';
import { RespuestaEstatusEnum } from '@enumeraciones/Enumeraciones.enum';

import { Alumno } from '@modelo/global/Alumno.model';

@Component(
  {
    selector: 'alumnomodal',
    templateUrl: './alumno.template.html',
    styleUrls: ['./alumno.component.scss']
  })

export class AlumnoModalComponent implements OnInit {
  @Output() respuesta = new EventEmitter();
  dataTable: Array<any>;

  public entidad: Alumno;

  public abierto!: boolean;
  public animacion!: string;

  @ViewChild('grid') private grid!: DxDataGridComponent;

  SelNivel: any[];
  SelGrado: any[];
  SelGrupo: any[];
  SelEstatus: any[];

  constructor(private appService: AppService, private mensajeService: MensajeService, public sistemaService: SistemaService, public translate: TranslateService) {
    this.entidad = new Alumno();
    this.dataTable = [];

    this.SelNivel = [];
    this.SelGrado = [];
    this.SelGrupo = [];
    this.SelEstatus = [];
  }

  ngOnInit() {
    this.setAlumnoEstatus();
    this.setNivel();
  }

  Modal() {
    this.animacion = this.sistemaService.animacionAbirModal;
    this.abierto = true;
  }

  CerrarModal() {
    this.LimpiarFiltros();
    this.animacion = this.sistemaService.animacionCerrarModal;

    setTimeout(() => {
      this.abierto = false;
    }, 310);
  }

  setAlumnoEstatus() {
    this.appService.Get("catalogo/alumnoestatus").then(res => {
      if (res.status == RespuestaEstatusEnum.Success) {
        this.SelEstatus = res.data
      }
    });
  }

  setNivel() {
    this.appService.Get("catalogo/nivel").then(res => {
      if (res.status == RespuestaEstatusEnum.Success) {
        this.SelNivel = res.data
      }
    });
  }
  setGrado(nivelid: number) {
    if (!nivelid) {
      this.SelGrado = [];
      this.entidad.gradoid = 0;
      this.setGrupo(0);
      return;
    }
    this.appService.Get("catalogo/grado/" + nivelid).then(res => {
      if (res.status == RespuestaEstatusEnum.Success) {
        this.SelGrado = res.data
      }
    });
  }
  setGrupo(gradoid: number) {
    if (!gradoid) {
      this.SelGrupo = [];
      this.entidad.grupoid = 0;
      return;
    }
    this.appService.Get("catalogo/grupo/" + gradoid).then(res => {
      if (res.status == RespuestaEstatusEnum.Success) {
        this.SelGrupo = res.data
      }
    });
  }

  LimpiarFiltros() {
    this.entidad = new Alumno();
    this.dataTable = [];
  }

  Buscar() {
    let data = new Alumno(this.entidad);
    this.appService.Post("catalogo/alumno", data).then(res => {
      if (res.status == RespuestaEstatusEnum.Success) {
        this.dataTable = res.data;
      }
    })
  }

  Guardar() {
    let checked = this.grid.instance.getSelectedRowsData();
    if (!checked.length) {
      return this.mensajeService.Alerta(AlertaEnum.Warning, "Seleccione uno o más registros");
    }
    this.respuesta.next(checked)

  }

}
